import { useEffect, useState } from "react";

/**
 * Revela `text` letra por letra (efeito de máquina de escrever).
 * Retorna o texto já visível e se a digitação terminou.
 */
export default function useTypewriter(text: string, speed = 45, startDelay = 350) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const prefersReduced =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReduced) {
      setCount(text.length);
      return;
    }

    setCount(0);
    let index = 0;
    let interval = 0;

    const start = window.setTimeout(() => {
      interval = window.setInterval(() => {
        index += 1;
        setCount(index);
        if (index >= text.length) {
          window.clearInterval(interval);
        }
      }, speed);
    }, startDelay);

    return () => {
      window.clearTimeout(start);
      window.clearInterval(interval);
    };
  }, [text, speed, startDelay]);

  return {
    displayed: text.slice(0, count),
    done: count >= text.length,
  };
}